// extracted by mini-css-extract-plugin
export default {"item":"SummaryPopup_item__T3vc9","block":"SummaryPopup_block__b-vdr","countBtn":"SummaryPopup_countBtn__Mweqx"};